import { render, staticRenderFns } from "./commo.vue?vue&type=template&id=528d190c&scoped=true"
import script from "./commo.vue?vue&type=script&lang=js"
export * from "./commo.vue?vue&type=script&lang=js"
import style0 from "./commo.vue?vue&type=style&index=0&id=528d190c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528d190c",
  null
  
)

export default component.exports